import { boolean, object, string } from 'yup';
import { BankHolidaysDeducting, CountryCode, RegionCode } from '../UserDataManagement';
const RequiredMessage = 'This field is required';
export const introEntitlementExceptionSchemaFunc = () => object({
    [RegionCode]: string().when(BankHolidaysDeducting, {
        is: (bankHolidays) => !bankHolidays,
        then: string().required(RequiredMessage).min(2, RequiredMessage),
    }),
    [CountryCode]: string().when(BankHolidaysDeducting, {
        is: (bankHolidays) => !bankHolidays,
        then: string().required(RequiredMessage).notOneOf(['00'], RequiredMessage),
    }),
    [BankHolidaysDeducting]: boolean(),
});
const introEntitlementExceptionSchema = introEntitlementExceptionSchemaFunc();
